<script>
const FALLBACK_DEFAULT_IMAGE_URL = '/img/clubs/departments/default.png';

export default {
    methods: {
        urlForListThumb(department, force = false) {
            return force || department.hasImage
                ? `${department.imageUrl}?size=list_thumb`
                : this.defaultDepartmentImageUrl();
        },
        defaultDepartmentImageUrl() {
            return window.kgr?.assetsUrls?.departmentDefaultImage || FALLBACK_DEFAULT_IMAGE_URL;
        },
        urlForDepartmentEdit(departmentId) {
            return `/backend/clubs/departments/${departmentId}/basicData`;
        },
    },
};
</script>
